<template>
    <vs-popup classContent="popup-example"  title="افزودن فاکتور جدید" :active.sync="showPopup">
        <div class="mb-base">
            <div class="center">
                <form class="p-4" @keydown.enter="addFactorInfo()">
                    <!-- <vs-alert color="rgb(41, 147, 138)" title="راهنما:" :active.sync="showPopup" class="mt-3">
                        <ul>
                            <li>متن راهنمای 1</li>
                            <li>متن راهنمای 2</li>
                        </ul>
                    </vs-alert> -->
                    <div class="vx-row px-5 my-4">
                        <div class="vx-col w-1/2">
                            <label class="vs-input--label"> عنوان </label>
                            <vs-input class="w-full" v-model="factor.title" name="title" v-validate="'required'" />
                            <span class="text-danger">{{ errors.first('title') }}</span>
                        </div>
                        <div class="vx-col w-1/2">
                            <label class="vs-input--label"> روش پرداخت </label>
                            <v-select :options="paymentMethod" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="factor.type" name="type" v-validate="'required'" />
                            <span class="text-danger">{{ errors.first('type') }}</span>
                        </div>
                    </div>

                    <div class="vx-row px-5 my-4">
                        <div class="vx-col w-full">
                            <label class="vs-input--label">توضیحات</label>
                            <vs-textarea v-model="factor.text" class="mt-4" />
                        </div>
                    </div>

                    <vs-divider class="mb-5" />
                    <vs-row vs-w="12" class="px-5">
                        <vs-col vs-w="2" class="px-2"></vs-col>
                        <vs-col vs-w="3" class="px-2">
                            <label class="vs-input--label">عنوان</label>
                        </vs-col>
                        <vs-col vs-w="2" class="px-2">
                            <label class="w-full vs-input--label">تعداد</label>
                        </vs-col>
                        <vs-col vs-w="2" class="px-2">
                            <label class="w-full vs-input--label">فی</label>
                        </vs-col>
                        <vs-col vs-w="2" class="px-2">
                            <label class="w-full vs-input--label">قیمت</label>
                        </vs-col>
                        <vs-col vs-w="1" class="px-2"></vs-col>
                        
                    </vs-row>
                    <draggable
                        :list="details"
                        tag="ul"
                        class="list-group list-group-flush"
                        handle=".handle"
                    >
                        <div v-for="(item, index) in details" :key="index" class="py-1">
                            <vs-row vs-w="12" class="px-5">
                                <vs-col vs-w="2" class="px-2">
                                    <vs-button class="mr-3 float-right btn-icon" color="danger" type="flat" @click="removeRow(index)" v-if="details.length > 1">
                                        <feather-icon icon="XIcon" />
                                    </vs-button>
                                    <feather-icon icon="AlignRightIcon" class="handle cursor-move" />
                                </vs-col>
                                <vs-col vs-w="3" class="px-2">
                                    <vs-input class="w-full" v-model="item.title" />
                                </vs-col>
                                <vs-col vs-w="2" class="px-2">
                                    <vs-input class="w-full input-center" v-model="item.quantity" @change="totalPrice(item.quantity, item.price, index)" />
                                </vs-col>
                                <vs-col vs-w="2" class="px-2">
                                    <vs-input class="w-full input-center" v-model="item.price" @change="totalPrice(item.quantity, item.price, index)" />
                                </vs-col>
                                <vs-col vs-w="2" class="px-2">
                                    <vs-input class="w-full input-center" readonly v-model="item.total_price" />
                                </vs-col>
                                <vs-col vs-w="1" class="px-2" style="margin-top:-16px;">
                                    <label v-if="item.type">هزینه</label>
                                    <label v-else>تخفیف</label>
                                    <vs-switch v-model="item.type" icon-pack="feather" vs-icon-off="icon-arrow-down" vs-icon-on="icon-arrow-up" class="mt-1" />
                                </vs-col>
                                
                            </vs-row>                          
                        </div>
                    </draggable>
                    
                    <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                        <vs-col class="sm:w-1/2 w-full">
                            
                        </vs-col>
                        <vs-col class="sm:w-1/2 w-full">
                            <vs-button class="mr-3 float-right" @click="addFactorInfo()" :disabled="!validateForm">ثبت</vs-button>
                            <vs-button class="mr-3 float-right" type="border" @click="addForm()">افزودن</vs-button>
                        </vs-col>
                    </vs-row>
                </form>
            </div>
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'
import draggable from 'vuedraggable'

// For custom error message
import { Validator } from 'vee-validate';
const dict = {
    custom: {
        title: {
            required: 'اجباری*',
        },
        type: {
            required: 'اجباری*',
        },
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    name: 'AddFactor',

    props: {
        popupAddFactor: {
            type: Boolean,
            default: false,
        },
        orderId: Number
    },
    
    components: {
        vSelect,
        draggable,
    },
    
    data() {
		return{
            showPopup: false,

			factor: {
				title: '',
				type: '',
                // status: '',
                // pay_time: '',
                fields: [],
                text: '',
            },

            details: [],
            
			paymentMethod: [
				{
					label: '70% پیش پرداخت و 30 % هنگام تحویل محصول',
					value: 'prepayment',
				},
				{
					label: '50% پیش پرداخت و 50% هنگام تحویل محصول',
					value: 'afterDelivery',
				},
				{
					label: '50% پیش پرداخت و 50% پس از نصب محصول',
					value: 'afterInstallation',
				},
				{
					label: '100% پس از نصب محصول',
					value: 'manual',
				},
                {
					label: 'فاکتور اختصاصی',
					value: 'custom',
				},
            ],
		}
    },
    
    computed: {
        validateForm() {
            return !this.errors.any() && this.factor.title != '' && this.factor.type != '';
        },
    },

    watch: { 
      	popupAddFactor: function(newVal) {
            this.showPopup = newVal
            if(newVal == true){
                this.$vs.loading()
                this.$store.dispatch('getOrderInfo', this.orderId)
                .then(res => {
                    this.$vs.loading.close()
                    if(res.data.data.type == 'product'){
                        let orders = res.data.data.desc
                        orders.forEach(order => {
                            if(order.frameType){
                                let frameType = {
                                    title: 'فریم ' + order.frameType.name,
                                    price: 0,
                                    total_price: 0,
                                    type: true,
                                    quantity: order.quantity,
                                }
                                this.details.push(frameType)
                            }

                            if(order.operatorType){
                                let operatorType = {
                                    title: 'اپراتور ' + order.operatorType.name,
                                    price: 0,
                                    total_price: 0,
                                    type: true,
                                    quantity: order.quantity,
                                }
                                this.details.push(operatorType)
                            }

                            if(order.glassType){
                                let glassType = {
                                    title: 'شیشه ' + order.glassType.name,
                                    price: 0,
                                    total_price: 0,
                                    type: true,
                                    quantity: order.quantity,
                                }
                                this.details.push(glassType)
                            }

                            if(order.sandblast == 'yes'){
                                let item = {
                                    title: 'سندبلاست',
                                    price: 0,
                                    total_price: 0,
                                    type: true,
                                    quantity: order.quantity,
                                }
                                this.details.push(item)
                            }
                        })
                        this.details.push({
                            title: 'ریموت',
                            price: 0,
                            total_price: 0,
                            type: true,
                            quantity: orders.length
                        })
                        this.details.push({
                            title: 'کاور پشت و رو',
                            price: 0,
                            total_price: 0,
                            type: true,
                            quantity: orders.length
                        })
                        this.details.push({
                            title: 'نصب و راه‌اندازی کامل توسط تکنسین‌های فنی آموزش دیده شرکت',
                            price: 0,
                            total_price: 0,
                            type: true,
                            quantity: orders.length
                        })
                        this.details.splice(0, 1);
                    }
                    else {
                        this.details.push({
                            title: '',
                            price: 0,
                            total_price: 0,
                            type: true,
                            quantity: 1
                        })
                        this.details.splice(0, 1);
                    }

                    this.factor.text = '- 9% مالیات بر ارزش افزوده در فاکتور نهایی لحاظ می گردد. \n- مدت اعتبار این پیش فاکتور 7 روز کاری می باشد. \n- کرایه حمل طبق بارنامه به عهده ی کارفرما می باشد.'

                    let type = {
                    label : '70% پیش پرداخت و 30 % هنگام تحویل محصول',
                    value : 'prepayment'
                    }
                    this.factor.type = type
                })
                .catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupAddFactor', newVal)
            this.factor = {
				title: '',
				type: '',
                // status: '',
                // pay_time: '',
                fields: [],
                text: '',
            }
            this.details = [
                {
                    title: '',
                    price: 0,
                    type: true,
                    quantity: 1,
                }
            ]
        },

        
    },

    created(){
    },
    
    methods: {
        updateItemQuantity(event, n) {
            this.orders[n].quantity = event
        },

        removeRow(i){
            if (i > -1) {
                this.details.splice(i, 1);
            }
        },

        addForm() {
            let item = {
                title: '',
                price: 0,
                total_price: 0,
                type: true,
                quantity: 1,
            }
            this.details.push(item)
        },

        totalPrice(quantity, price, index){
            this.details[index].total_price = quantity * price
        },

        addFactorInfo() {
            this.$vs.loading()
            this.$emit('updatePopupAddFactor', false)
            this.details.forEach(item => {
                if(item.type == true) {
                    item.type = 'increase'
                }
                else {
                    item.type = 'decrease'
                }
            });
            let payload = {
                order_id: this.orderId,
                title: this.factor.title,
                type: this.factor.type.value,
                // status: this.factor.status,
                // pay_time: this.factor.pay_time,
                fields: this.details,
                text: this.factor.text
            }
            this.factor = {
				title: '',
				type: '',
                status: '',
                pay_time: '',
                fields: [],
                text: ''
            }
            this.details = [
                {
                    title: '',
                    price: 0,
                    type: true
                }
            ]
            this.$store.dispatch('addFactor', payload)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'فاکتور با موفقیت افزوده شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
                })
                location.reload()
                // $router.push('factors').catch(() => {})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات وارد شده صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        }
    }
}
</script>

<style scope>
.con-vs-popup .vs-popup {
    width: 80% !important;
}

.input-center input[type = 'text'] {
    text-align: center !important;
}

.handle {
  padding-top: 8px;
}
</style>